import { Product } from '@@types'
import { useTranslation } from 'react-i18next'

import CommentCartModal from '@features/cart/ui/comment/modal/CartCommentModal'
import styles from '@features/cart/ui/comment/modal/CartCommentModal.module.scss'
import { useModalStore } from '@features/modal'





export default function useCartComment () {
  const { openModal, closeModal } = useModalStore()
  const { t: tc } = useTranslation('cart')

  const openCartCommentModal = (product: Product) => {
    openModal('cartComment', <CommentCartModal data={product} />, {
      title: tc('product.comment'),

      classes: {
        content: styles['modal-content'],
      },
    })
  }

  const closeCartCommentModal = () => {
    closeModal('cartComment')
  }

  return {
    openCartCommentModal,
    closeCartCommentModal,
  }
}